import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Hero.css";

const PROJECTS = [
  {
    name: "Genesis",
    image: "/images/genesis.png",
    category: "Real Estate"
  },
  {
    name: "Shiri Infra",
    image: "/images/shiriinfra.png",
    category: "Construction"
  },
  {
    name: "GenServices",
    image: "/images/genservice.png",
    category: "Services"
  },
  {
    name: "Nutsby",
    image: "/images/nutsby.png",
    category: "E-Commerce"
  }
];

const Hero = ({ onPortfolioSelect }) => {
  const [currentProject, setCurrentProject] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentProject((prev) => (prev + 1) % PROJECTS.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    },
  };

  const floatingVariants = {
    animate: {
      y: [0, -15, 0],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  const slideVariants = {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 },
    transition: { duration: 0.8, ease: "easeInOut" }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <div className="hero-blob hero-blob-1"></div>
        <div className="hero-blob hero-blob-2"></div>
      </div>

      <motion.div
        className="hero-container"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <div className="hero-left">
          <motion.span className="hero-badge" variants={itemVariants}>
            #1 Digital Growth Partner
          </motion.span>

          <motion.h1 variants={itemVariants}>
            Dominate Your Market with
            <span> Precision Marketing</span>
          </motion.h1>

          <motion.p variants={itemVariants}>
            We don't just run campaigns; we build <strong>High-Performance Growth Engines</strong>. 
            Scaling brands with data-driven strategies and creative brilliance.
          </motion.p>

          <motion.div className="hero-buttons" variants={itemVariants}>
            <button
              onClick={() => onPortfolioSelect()}
              className="btn-primary"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              View Portfolio
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>

            <a href="#services" className="btn-secondary">
              Our Services
            </a>
          </motion.div>

          <motion.div className="hero-stats" variants={itemVariants}>
            <div>
              <h2>120+</h2>
              <p>Campaigns</p>
            </div>

            <div>
              <h2>300%</h2>
              <p>Avg. ROI</p>
            </div>

            <div>
              <h2>50+</h2>
              <p>Scale Ups</p>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="hero-right"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <div className="visual-container">
            <motion.div
              className="main-glass-card slideshow-card"
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            >
              <div className="slideshow-container">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={currentProject}
                    variants={slideVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    className="slide"
                  >
                    <div className="slide-image-wrapper">
                      <img 
                        src={PROJECTS[currentProject].image} 
                        alt={PROJECTS[currentProject].name} 
                        className="slide-image"
                      />
                      <div className="slide-overlay">
                        <span className="slide-category">{PROJECTS[currentProject].category}</span>
                        <h3>{PROJECTS[currentProject].name}</h3>
                      </div>
                    </div>
                  </motion.div>
                </AnimatePresence>
                
                <div className="slideshow-dots">
                  {PROJECTS.map((_, index) => (
                    <div 
                      key={index} 
                      className={`dot ${index === currentProject ? 'active' : ''}`}
                    />
                  ))}
                </div>
              </div>
            </motion.div>

            <motion.div
              className="floating-card card-1"
              variants={floatingVariants}
              animate="animate"
            >
              <h4>Revenue Growth</h4>
              <p className="value">$84.2k <span className="trend up">↑ 24%</span></p>
            </motion.div>

            <motion.div
              className="floating-card card-2"
              variants={floatingVariants}
              animate="animate"
              transition={{ delay: 0.5, duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
            >
              <h4>New Leads</h4>
              <p className="value">1,420 <span className="trend up">↑ 18%</span></p>
            </motion.div>

            <motion.div
              className="floating-card card-3"
              variants={floatingVariants}
              animate="animate"
              transition={{ delay: 1, duration: 5, repeat: Infinity, ease: "easeInOut" }}
            >
              <h4>Efficiency</h4>
              <p className="value">94%</p>
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
